export default __webpack_public_path__ + "static/media/Reimbursement_3.176058be.png";